import { create } from "zustand";
import type { Staff } from "../types";

interface StaffState {
	modalOpen: boolean;
	editingItem: Staff | null;
}

interface StaffActions {
	openCreateModal: () => void;
	openEditModal: (item: Staff) => void;
	closeModal: () => void;
}

type StaffStore = StaffState & StaffActions;

export const useStaffStore = create<StaffStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingItem: null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null });
	},
}));
